import { brand } from "@/data/site";

export default function Privacy() {
    return (
        <div data-testid="page-privacy" className="wx-container py-10">
            <h1 className="text-2xl font-semibold text-[color:var(--wx-ink)] tracking-tight">
                Kebijakan Privasi
            </h1>
            <p className="mt-1 text-xs text-[color:var(--wx-muted)]">
                Terakhir diperbarui: September 2026
            </p>

            <div className="mt-5 space-y-4 text-sm text-[color:var(--wx-ink2)] leading-relaxed">
                <p>
                    {brand.legal} (selanjutnya “{brand.name}”, “kami”)
                    menghormati privasi setiap customer. Kebijakan ini
                    menjelaskan bagaimana kami mengumpulkan dan menggunakan
                    informasi Anda saat memakai layanan kami.
                </p>

                <div>
                    <h2 className="text-base font-semibold text-[color:var(--wx-ink)]">
                        1. Data yang dikumpulkan
                    </h2>
                    <p className="mt-1">
                        Kami mengumpulkan data yang Anda kirim sukarela lewat
                        WhatsApp, Instagram, atau kanal resmi lain: nama, nomor
                        kontak, alamat pengiriman, dan detail pesanan.
                    </p>
                </div>
                <div>
                    <h2 className="text-base font-semibold text-[color:var(--wx-ink)]">
                        2. Penggunaan data
                    </h2>
                    <p className="mt-1">
                        Data digunakan untuk memproses pesanan, update status,
                        invoice, dan pengiriman.
                    </p>
                </div>
                <div>
                    <h2 className="text-base font-semibold text-[color:var(--wx-ink)]">
                        3. Berbagi data
                    </h2>
                    <p className="mt-1">
                        Data pengiriman hanya dibagikan ke kurir dan penyedia
                        pembayaran sebatas yang diperlukan. Kami tidak menjual
                        data customer.
                    </p>
                </div>
                <div>
                    <h2 className="text-base font-semibold text-[color:var(--wx-ink)]">
                        4. Keamanan
                    </h2>
                    <p className="mt-1">
                        Kami membatasi penggunaan data customer hanya untuk keperluan
        operasional layanan WxFaous. Link privat pesanan dikirim langsung
        kepada customer terkait dan tidak dipublikasikan secara umum.
                    </p>
                </div>
                <div>
                    <h2 className="text-base font-semibold text-[color:var(--wx-ink)]">
                        5. Hak Anda
                    </h2>
                    <p className="mt-1">
                        Anda dapat meminta perbaikan/penghapusan data pribadi
                        Anda melalui{" "}
                        <a
                            href={`mailto:${brand.email}`}
                            className="text-[color:var(--wx-blue)] underline underline-offset-2"
                        >
                            {brand.email}
                        </a>
                        .
                    </p>
                </div>
            </div>
        </div>
    );
}
